<template>
  <div id="page">
    <NavBar />
    <div class="sub_header_in sticky_header">
      <div class="container">
        <h1>{{ $t('lang.transfer.transfer') }}</h1>
      </div>
    </div>
    <div class="container margin_60_35 pb-5">
      <TransferForm
        :city="city"
        :store-id="storeId"
      />
    </div>
    <FooterComponent />
  </div>
</template>

<script>
import TransferForm from '@/components/Transfer/TransferForm';
import FooterComponent from '@/components/FooterComponent';
import NavBar from '@/components/NavBar/NavBar';
import { cities } from '@/data/cities';

export default {
  name: 'Transfer',
  components: { NavBar, TransferForm, FooterComponent },
  data() {
    return {
      city: {
        id: null,
        bd_city_id: null,
        isRideType: false,
      },
      storeId: null,
    };
  },

  created() {
    if (this.$route.query.store_id) {
      this.storeId = this.$route.query.store_id;
    }

    try {
      let city = null;
      if (isNaN(this.$route.params.city_id)) {
        city = cities.find((data) => data.id === this.$route.params.city_id);
      } else {
        city = cities.find((data) => data.bd_city_id === Number(this.$route.params.city_id));

        this.$router.replace({
          path: `/transfer/${city.id}`,
          query: this.$route.query,
        });
      }
      this.city.id = city.id;
      this.city.bd_city_id = city.bd_city_id;
      if (city.transfer_type_is_ride) {
        this.city.isRideType = true;
      }
    } catch (error) {
      this.$router.push('/bookings');
    }
  },
};
</script>

<style scoped>

</style>
